import { z } from 'zod';
export enum AgencyCampaignSection {
  Brands = 'brands',
  Supply = 'supply',
  ChannelGroups = 'channel-groups',
  Campaigns = 'campaigns',
  LineItems = 'line-items',
  Creatives = 'creatives',
}
export const agencyCampaignSectionSchema = z.enum(AgencyCampaignSection);
export const agencyCampaignLabels = {
  [AgencyCampaignSection.Brands]: 'nav.campaigns.brands',
  [AgencyCampaignSection.Supply]: 'nav.campaigns.supply',
  [AgencyCampaignSection.ChannelGroups]: 'nav.campaigns.channelGroups',
  [AgencyCampaignSection.Campaigns]: 'nav.campaigns.campaigns',
  [AgencyCampaignSection.LineItems]: 'agencyWorkspace.lineItems',
  [AgencyCampaignSection.Creatives]: 'nav.campaigns.creatives',
} as const;

export function agencyWorkspaceTitle(pathname: string) {
  if (pathname.endsWith('/reporting/report-explorer'))
    return 'nav.reporting.reportExplorer' as const;
  if (pathname.endsWith('/reporting/saved-reports')) return 'nav.reporting.savedReports' as const;
  if (pathname.endsWith('/campaigns/overview')) return 'agencyAssignment.label' as const;
  if (/\/campaigns\/brands\/[^/]+\/details$/.test(pathname)) return 'nav.campaigns.brands' as const;
  const section = agencyCampaignSectionSchema.safeParse(pathname.split('/campaigns/')[1]);
  return section.success ? agencyCampaignLabels[section.data] : ('agencyWorkspace.title' as const);
}

export enum AgencyEditorMode {
  Create = 'create',
  Edit = 'edit',
  Duplicate = 'duplicate',
}
